import React from 'react';
import { IRepeatableWidgetProps } from './RepeatableWidgetComponent';
import { RepeatableContainer } from './style/RepeatableContainer';

export function RepeatableWidgetPreview(props: IRepeatableWidgetProps) {
  const { widget } = props;

  return (
    <RepeatableContainer
      description={widget.description}
      buttonText={widget.layout?.buttonText}
      hideNumberItems={widget.layout?.hideNumberItem}
      hideBorder={widget.layout?.hideBorder}
      hideAddButton={widget.layout?.hideAddButton}
      label={widget?.label}
    >
      {props.children}
    </RepeatableContainer>
  );
}
